import {makeGet, makePost} from "../Functions";
import {FetchEvents, RequestGroup} from "../RequestGroup";
import {LoginResponse} from "../jtmc/models/LoginResponse";
import {LoginConfirmResponse} from "../jtmc/models/LoginConfirmResponse";
import ClientInfo from "../jtmc/models/ClientInfo";
import {Model} from "../jtmc/Model";
import Order from "../jtmc/models/Order";

export class Auth extends RequestGroup {
    requests = {
        login: (data: any) => {
            return this.customPromise((events: FetchEvents)=>{
                makePost("/auth/login", data, null, events, false);
            }, {class: LoginResponse, isArray: false})
        },
        confirm: (data: any) => {
            data.role = "client";
            return this.customPromise((events: FetchEvents)=>{
                makePost("/auth/confirm", data, null, events, false);
            }, {class: LoginConfirmResponse, isArray: false})
        },
        guest: (data: any) => {
            data.role = "client";
            return this.customPromise((events: FetchEvents)=>{
                makePost("/auth/guest", data, null, events, false);
            }, {class: LoginConfirmResponse, isArray: false})
        },
        guestSendConfirmCode: (data: any) => {
            data.role = "client";
            return this.customPromise((events: FetchEvents)=>{
                makePost("/guest/login", data, null, events, true);
            }, {class: LoginConfirmResponse, isArray: false})
        },
        guestConfirmCode: (data: any) => {
            data.role = "client";
            return this.customPromise((events: FetchEvents)=>{
                makePost("/guest/confirm", data, null, events, true);
            }, {class: Model, isArray: false})
        },
        pushSub: (data: any, events: FetchEvents) => {
            makePost("/push-sub", data, null, events, true);
        },
        pushUnSub: (data: any, events: FetchEvents) => {
            makePost("/push-unsub", data, null, events, true);
        },
        clientInfo: () => {
            return this.customPromise((events: FetchEvents)=>{
                makeGet("/clientInfo", null, events, true);
            }, {class: ClientInfo, isArray: false})
        },
        setName: (name:string) => {
            return this.customPromise((events: FetchEvents)=>{
                makePost("/nameEditInfo", {}, {
                    name: name
                }, events, true);
            }, {class: Model, isArray: false})
        },
        ordersHistory: () => {
            return this.customPromise((events: FetchEvents)=>{
                makeGet("/ordersHistory",  {}, events, true);
            }, {class: Order, isArray: true})
        }
    }
}